import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import type { CollectionSummary } from "./useSiteListActions";
import type { JSX } from "react";

interface CollectionProgressProps {
  kind: "starting" | "progress" | "completed" | "error";
  summary: CollectionSummary | null;
  errorMessage: string | null;
  onDismiss: () => void;
  onCancel: () => void;
}

export function CollectionProgress(props: CollectionProgressProps) {
  let collectionProgress: JSX.Element | null;
  const { kind, summary, errorMessage, onDismiss, onCancel } = props;
  if (kind === "starting") {
    collectionProgress = (
      <Alert severity="info" sx={{ mb: 2 }}>
        Запуск сбора параметров...
      </Alert>
    );
  } else {
    if (kind === "error") {
      collectionProgress = (
      <Alert severity="error" sx={{ mb: 2 }} action={<Button size="small" onClick={onDismiss}>Закрыть</Button>}>
        Ошибка сбора параметров: {errorMessage}
      </Alert>
    );
    } else {
      if (kind === "completed" && summary) {
        collectionProgress = (
      <Alert severity="success" sx={{ mb: 2 }} action={<Button size="small" onClick={onDismiss}>Закрыть</Button>}>
        Сбор параметров завершён: {summary.successCount} успешно, {summary.failedCount} с ошибками
      </Alert>
    );
      } else {
        if (kind === "progress" && summary) {
          const percent = summary.totalSites > 0 ? (summary.processedCount / summary.totalSites) * 100 : 0;
          collectionProgress = (
      <Box sx={{ mb: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
          <Typography variant="body2">
            Сбор параметров: {summary.processedCount} / {summary.totalSites}
          </Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="body2" color="text.secondary">
              Успешно: {summary.successCount} | Ошибок: {summary.failedCount}
            </Typography>
            <Button size="small" color="error" onClick={onCancel}>
              Отменить
            </Button>
          </Box>
        </Box>
        <LinearProgress variant="determinate" value={percent} />
      </Box>
    );
        } else {
          collectionProgress = null;
        }
      }
    }
  }
  return collectionProgress;
}
